// Author lidongxu
// Date 2024-04-02 14:37:44

class SithMesStoolPrApplicationRecord {
    constructor({
                    id = null,
                    status = '',
                    workOrderCode = '',
                    applicationNo = '',
                    type = '',
                    budget = '',
                    pmHead = '',
                    pmHeadApproveDate = '',
                    cpmHead = '',
                    cpmHeadApproveDate = '',
                    departmentManager = '',
                    departmentManagerApproveDate = '',
                    baManager = '',
                    baManagerApproveDate = '',
                    ceo = '',
                    ceoApproveDate = '',
                    cfo = '',
                    cfoApproveDate = '',
                    remark = '',
                    shippingDetailList = '',
                    indirectPurchaseDetail = ''}
                        = {}) {
        this.id = id;
        this.status = status;
        this.workOrderCode = workOrderCode;
        this.applicationNo = applicationNo;
        this.type = type;
        this.budget = budget;
        this.pmHead = pmHead;
        this.pmHeadApproveDate = pmHeadApproveDate;
        this.cpmHead = cpmHead;
        this.cpmHeadApproveDate = cpmHeadApproveDate;
        this.departmentManager = departmentManager;
        this.departmentManagerApproveDate = departmentManagerApproveDate;
        this.baManager = baManager;
        this.baManagerApproveDate = baManagerApproveDate;
        this.ceo = ceo;
        this.ceoApproveDate = ceoApproveDate;
        this.cfo = cfo;
        this.cfoApproveDate = cfoApproveDate;
        this.remark = remark;
        this.shippingDetailList = shippingDetailList;
        this.indirectPurchaseDetail = indirectPurchaseDetail;
    }
}

function newEntity() {
    return new SithMesStoolPrApplicationRecord();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'workOrderCode',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.workOrderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applicationNo',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.applicationNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchasingType',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.purchasingType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemType',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.itemType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'budget',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.budget',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'department',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.department',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdByName',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.createdByName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'pmHead',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.pmHead',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'pmHeadApproveDate',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.pmHeadApproveDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'cpmHead',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.cpmHead',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'cpmHeadApproveDate',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.cpmHeadApproveDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'departmentManager',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.departmentManager',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'departmentManagerApproveDate',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.departmentManagerApproveDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baManager',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.baManager',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baManagerApproveDate',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.baManagerApproveDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ceo',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.ceo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'ceoApproveDate',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.ceoApproveDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'cfo',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.cfo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'cfoApproveDate',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.cfoApproveDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'statusName',
            label: 'label.sith.stool.sithMesStoolPrApplicationRecord.grid.statusName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    statusFilter : '',
    workOrderCodeFilter : '',
    applicationNoFilter : '',
    departmentFilter : '',
    typeInFilter : [],
    budgetRteFilter : '',
    budgetLteFilter : '',
    applicantFilter : '',
    applyDateRteFilter : '',
    applyDateLteFilter : '',
    pmHeadFilter : '',
    pmHeadApproveDateRteFilter : '',
    pmHeadApproveDateLteFilter : '',
    cpmHeadFilter : '',
    cpmHeadApproveDateRteFilter : '',
    cpmHeadApproveDateLteFilter : '',
    departmentManagerFilter : '',
    departmentManagerApproveDateRteFilter : '',
    departmentManagerApproveDateLteFilter : '',
    baManagerFilter : '',
    baManagerApproveDateRteFilter : '',
    baManagerApproveDateLteFilter : '',
    ceoFilter : '',
    ceoApproveDateRteFilter : '',
    ceoApproveDateLteFilter : '',
    cfoFilter : '',
    cfoApproveDateRteFilter : '',
    cfoApproveDateLteFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'statusFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.status',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
            ,selectFilter:{processBusinessEntityFilter:'SithMesStoolPrApplicationRecord',statusFilter:1}
        }
    },
    {
        key: 'workOrderCodeFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.workOrderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applicationNoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.applicationNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'departmentFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.department',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'typeInFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.typeIn',
        disabled: false,
        form: {
            type: 'entitySelectMultiple',
            modalMultiSelectedType: 'string'
            ,entity: 'sithMesStoolPrApplicationTypeConfig'
            ,correspondingField: 'id'
        }
    },
    {
        key: 'budgetRteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.budgetRte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'budgetLteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.budgetLte',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applicantFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.applicant',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.applyDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.applyDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmHeadFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.pmHead',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmHeadApproveDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.pmHeadApproveDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmHeadApproveDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.pmHeadApproveDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cpmHeadFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.cpmHead',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cpmHeadApproveDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.cpmHeadApproveDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cpmHeadApproveDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.cpmHeadApproveDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'departmentManagerFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.departmentManager',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'departmentManagerApproveDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.departmentManagerApproveDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'departmentManagerApproveDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.departmentManagerApproveDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baManagerFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.baManager',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baManagerApproveDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.baManagerApproveDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baManagerApproveDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.baManagerApproveDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ceoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.ceo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ceoApproveDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.ceoApproveDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ceoApproveDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.ceoApproveDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cfoFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.cfo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cfoApproveDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.cfoApproveDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cfoApproveDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.filter.cfoApproveDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'applicationNo',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.applicationNo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'type',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.type',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            ,entity: 'sithMesStoolPrApplicationTypeConfig'
            ,correspondingField: 'id'
        }
    },
    {
        key: 'budget',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.budget',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmHead',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.pmHead',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pmHeadApproveDate',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.pmHeadApproveDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cpmHead',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.cpmHead',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cpmHeadApproveDate',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.cpmHeadApproveDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'departmentManager',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.departmentManager',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'departmentManagerApproveDate',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.departmentManagerApproveDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baManager',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.baManager',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baManagerApproveDate',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.baManagerApproveDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ceo',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.ceo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'ceoApproveDate',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.ceoApproveDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cfo',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.cfo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'cfoApproveDate',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.cfoApproveDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPrApplicationRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
]

export {SithMesStoolPrApplicationRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
